"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base = '/svc/ride-hailing/chauffeur-incentive';
/**
 * @private
 */
exports.RIDE_HAILING_ENDPOINT = {
    putPayoutStatus: base + "/chauffeur-payouts/{{payoutUuid}}/mark-as-paid",
    getPayoutDetails: base + "/chauffeur-payouts/detail/{{payoutUuid}}",
    incentiveDetails: base + "/incentive-configurations/{{incentiveUuid}}",
    incentiveList: base + "/incentive-configurations",
};
